import React from 'react'

const ShippingOne = () => {
    // ✅ Updated Theme Colors
    const colors = {
        blue: '#083d74',
        orange: '#f5a623',
        background: '#f0f4f8', // Light blue tint background for hover
    };

    const shippingData = [
        {
            icon: "ph-truck", // Changed car to truck for better shipping feel
            title: "Affordable Shipping",
            desc: "Shipping all over India"
        },
        {
            icon: "ph-hand-heart",
            title: "100% Satisfaction",
            desc: "Quality guarantee on every order"
        },
        {
            icon: "ph-credit-card",
            title: "Secure Payments",
            desc: "Safe and encrypted transactions"
        },
        {
            icon: "ph-chats",
            title: "24/7 Support",
            desc: "Expert help whenever you need it"
        }
    ];

    return (
        <section className="shipping" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">
                    {shippingData.map((item, index) => (
                        <div className="col-xxl-3 col-sm-6" key={index}>
                            <div 
                                className="shipping-item flex-align gap-16 rounded-16 transition-2"
                                style={{ 
                                    backgroundColor: 'white',
                                    border: `1px solid ${colors.blue}15`, // Very light blue border
                                    padding: '24px'
                                }}
                            >
                                {/* ✅ Icon Box - Now Blue */}
                                <span 
                                    className="w-56 h-56 flex-center rounded-circle text-white text-32 flex-shrink-0 transition-2 icon-box"
                                    style={{ backgroundColor: colors.blue }}
                                >
                                    <i className={`ph-fill ${item.icon}`} />
                                </span>
                                <div className="">
                                    {/* ✅ Title - Now Blue */}
                                    <h6 className="mb-0" style={{ color: colors.blue, fontWeight: '700' }}>
                                        {item.title}
                                    </h6>
                                    <span className="text-sm text-heading" style={{ opacity: 0.8 }}>
                                        {item.desc}
                                    </span>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* ✅ Updated Hover Effects */}
            {/* ✅ Updated Hover Effects with Green Icon Change */}
<style>{`
    .shipping-item {
        transition: all 0.3s ease;
        cursor: pointer;
    }
    .shipping-item:hover {
        border-color: ${colors.blue} !important;
        background-color: ${colors.background} !important;
        transform: translateY(-5px);
        box-shadow: 0 10px 20px rgba(8, 61, 116, 0.1);
    }
   
`}</style>
        </section>
    )
}

export default ShippingOne;